import React from "react";
import CG_FooterButtons from "./CG_FooterButtons";

export default function CG_PropertyDetails({ setFormData, formData, setCurrentScreen, currentScreen, navigate, screen }) {
    const handleNext = (e) => {
        e.preventDefault();
        if (!formData.address1 || !formData.propertyType1 || !formData.size1 || !formData.stories1) {
            alert("Please fill out all required fields.");
            return;
        }
        setCurrentScreen(1);
        console.log("Form submitted successfully:", formData);
        // Proceed with further actions, such as navigating or API calls.
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((pre) => ({ ...pre, [name]: value }));
    };
    return (
        <form className=" tw-h-full  tw-flex tw-flex-col tw-justify-between " onSubmit={handleNext}>
            <div className="tw-px-[5%]  ">
                <h2 className="tw-mt-5 tw-text-center tw-font-[700] tw-text-[30px] tw-text-[#001659]">Property Details</h2>
                <div className="tw-w-full tw-flex tw-justify-between tw-gap-3 xl:tw-gap-10 tw-flex-col xl:tw-flex-row tw-mt-5">
                    <div className="tw-w-full xl:tw-w-1/2">
                        <p className="tw-font-[600]">Address:</p>
                        <input
                            placeholder="Enter your address"
                            required
                            name="address1"
                            value={formData.address1}
                            onChange={handleInputChange}
                            className="tw-bg-[#f1f1f1] tw-w-full tw-rounded-md tw-px-2 tw-py-1"
                        />
                    </div>
                    <div className="tw-w-full xl:tw-w-1/2">
                        <p className="tw-font-[600]">Address:</p>
                        <input
                            placeholder="Enter your address"
                            required
                            name="address2"
                            value={formData.address2}
                            onChange={handleInputChange}
                            className="tw-bg-[#f1f1f1] tw-w-full tw-rounded-md tw-px-2 tw-py-1"
                        />
                    </div>
                </div>
                <div className="tw-w-full tw-flex tw-justify-between tw-flex-col xl:tw-flex-row  tw-gap-3 tw-mt-3 xl:tw-gap-10 xl:tw-mt-3">
                    <div className="tw-w-full xl:tw-w-1/2">
                        <p className="tw-font-[600]">Property Type:</p>
                        <select
                            onChange={handleInputChange}
                            required
                            value={formData.propertyType1}
                            name="propertyType1"
                            className="tw-bg-[#f1f1f1] tw-w-full tw-rounded-md tw-px-2 tw-py-1"
                        >
                            <option value={"House"}>House</option>
                            <option value={"Plote"}>Plote</option>
                            <option value={"Agriculture"}>Agriculture</option>
                        </select>
                    </div>
                    <div className="tw-w-full xl:tw-w-1/2">
                        <p className="tw-font-[600]">Property Type:</p>
                        <select
                            onChange={handleInputChange}
                            required
                            value={formData.propertyType2}
                            name="propertyType2"
                            className="tw-bg-[#f1f1f1] tw-w-full tw-rounded-md tw-px-2 tw-py-1"
                        >
                            <option value={"House"}>House</option>
                            <option value={"Plote"}>Plote</option>
                            <option value={"Agriculture"}>Agriculture</option>
                        </select>{" "}
                    </div>
                </div>
                <div className="tw-w-full tw-flex tw-flex-col xl:tw-flex-row tw-justify-between tw-gap-3 tw-mt-3 xl:tw-gap-10 xl:tw-mt-3">
                    <div className="tw-w-full xl:tw-w-1/2">
                        <p className="tw-font-[600]">Size:</p>
                        <div className="tw-bg-[#f1f1f1] tw-w-full tw-rounded-md tw-flex tw-justify-between tw-px-2 tw-py-1">
                            <input
                                placeholder="Enter Size"
                                onChange={handleInputChange}
                                required
                                value={formData.size1}
                                name="size1"
                                className="tw-w-[80%] tw-bg-transparent tw-outline-none"
                            />
                            <select>
                                <option>Sqft</option>
                                <option>Sqft</option>
                                <option>Sqft</option>
                            </select>
                        </div>
                    </div>
                    <div className="tw-w-full xl:tw-w-1/2">
                        <p className="tw-font-[600]">Size:</p>
                        <div className="tw-bg-[#f1f1f1] tw-w-full tw-rounded-md tw-flex tw-justify-between tw-px-2 tw-py-1">
                            <input
                                placeholder="Enter Size"
                                onChange={handleInputChange}
                                required
                                value={formData.size2}
                                name="size2"
                                className="tw-w-[80%] tw-bg-transparent tw-outline-none"
                            />
                            <select>
                                <option>Sqft</option>
                                <option>Sqft</option>
                                <option>Sqft</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="tw-w-full tw-flex tw-flex-col xl:tw-flex-row tw-justify-between tw-gap-3 tw-mt-3 xl:tw-gap-10 xl:tw-mt-3">
                    <div className="tw-w-full xl:tw-w-1/2">
                        <p className="tw-font-[600]">Number of Stories:</p>
                        <div className="tw-bg-[#f1f1f1] tw-w-full tw-rounded-md tw-flex tw-justify-between tw-px-2 tw-py-1">
                            <input
                                placeholder="Enter Size"
                                onChange={handleInputChange}
                                required
                                value={formData.stories1}
                                name="stories1"
                                className="tw-w-[80%] tw-bg-transparent tw-outline-none"
                            />
                            <select>
                                <option>Select Number</option>
                                <option>Sqft</option>
                                <option>Sqft</option>
                            </select>
                        </div>
                    </div>
                    <div className="tw-w-full xl:tw-w-1/2">
                        <p className="tw-font-[600]">Number of Stories:</p>
                        <div className="tw-bg-[#f1f1f1] tw-w-full tw-rounded-md tw-flex tw-justify-between tw-px-2 tw-py-1">
                            <input
                                placeholder="Enter Size"
                                onChange={handleInputChange}
                                required
                                value={formData.stories2}
                                name="stories2"
                                className="tw-w-[80%] tw-bg-transparent tw-outline-none"
                            />
                            <select>
                                <option>Select Number</option>
                                <option>Sqft</option>
                                <option>Sqft</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="tw-w-full tw-flex tw-flex-col xl:tw-flex-row tw-justify-between tw-gap-3 tw-mt-3 xl:tw-gap-10 xl:tw-mt-3">
                    <div className="tw-w-full xl:tw-w-1/2">
                        <p className="tw-font-[600]">Option:</p>
                        <input
                            placeholder="Enter your Option"
                            onChange={handleInputChange}
                            required
                            value={formData.option1}
                            name="option1"
                            className="tw-bg-[#f1f1f1] tw-w-full tw-rounded-md tw-px-2 tw-py-1"
                        />
                    </div>
                    <div className="tw-w-full xl:tw-w-1/2">
                        <p className="tw-font-[600]">Option:</p>
                        <input
                            placeholder="Enter your Option"
                            onChange={handleInputChange}
                            required
                            value={formData.option2}
                            name="option2"
                            className="tw-bg-[#f1f1f1] tw-w-full tw-rounded-md tw-px-2 tw-py-1"
                        />
                    </div>
                </div>
                <div className="tw-w-full tw-flex tw-flex-col xl:tw-flex-row tw-justify-between tw-gap-3 tw-mt-3 xl:tw-gap-10 xl:tw-mt-3">
                    <div className="tw-w-full xl:tw-w-1/2">
                        <p className="tw-font-[600]">Option:</p>
                        <input
                            placeholder="Enter your Option"
                            onChange={handleInputChange}
                            required
                            value={formData.option3}
                            name="option3"
                            className="tw-bg-[#f1f1f1] tw-w-full tw-rounded-md tw-px-2 tw-py-1"
                        />
                    </div>
                    <div className="tw-w-full xl:tw-w-1/2">
                        <p className="tw-font-[600]">Option:</p>
                        <input
                            placeholder="Enter your Option"
                            onChange={handleInputChange}
                            required
                            value={formData.option4}
                            name="option4"
                            className="tw-bg-[#f1f1f1] tw-w-full tw-rounded-md tw-px-2 tw-py-1"
                        />
                    </div>
                </div>
            </div>
            <CG_FooterButtons currentScreen={currentScreen} setCurrentScreen={setCurrentScreen} navigate={navigate} />
        </form>
    );
}
